// B1 only: no runtime registration, ORM, engine or permission dependencies.
const SCHEMA_VERSION = 2;
const STRUCTURE_KINDS = Object.freeze(["simple", "composite"]);
const CLIENT_DISPLAYS = Object.freeze(["descriptions", "priced"]);
const ECONOMIC_LINE_TYPES = Object.freeze(["service", "material", "subcontracting"]);
const DESCRIPTIVE_LINE_TYPES = Object.freeze(["text", "subtotal"]);
const QUANTITY_LIMITS = Object.freeze({
  localPrecision: 14, localScale: 4,
  // Exact representation budget, not a business depth limit. Never round a product.
  derivedPrecision: 28, derivedScale: 28, maxMagnitude: "9999999999.9999",
});
const ABANDONED_FIELDS = Object.freeze([
  "compositionPricingMode", "composition_pricing_mode", "independentPrice",
  "independent_price", "independentPriceBasis", "independent_price_basis",
]);
const object = (value) => value !== null && typeof value === "object" && !Array.isArray(value);
const own = (value, key) => Object.hasOwn(value, key);
const id = (value) => typeof value === "string" && value.trim() === value && value.length > 0
  ? value : typeof value === "number" && Number.isSafeInteger(value) && value > 0 ? String(value) : null;
const scopeKey = (scope) => {
  if (!object(scope)) return null;
  if (scope.kind === "main" && scope.optionId == null) return "main";
  if (scope.kind === "option" && id(scope.optionId) !== null) return `option:${id(scope.optionId)}`;
  return null;
};
const copyScope = (scope) => scope.kind === "main" ? { kind: "main" }
  : { kind: "option", optionId: id(scope.optionId) };
const issue = (code, message, context = {}, status = 400) => ({ code, status, message, ...context });
const result = (errors, extra = {}) => ({ valid: errors.length === 0, errors, ...extra });

module.exports = { SCHEMA_VERSION, STRUCTURE_KINDS, CLIENT_DISPLAYS, ECONOMIC_LINE_TYPES,
  DESCRIPTIVE_LINE_TYPES, QUANTITY_LIMITS, ABANDONED_FIELDS, object, own, id, scopeKey, copyScope, issue, result };
